import { ChangeEvent, FC, useState } from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import { unwrapResult } from "@reduxjs/toolkit";
import { DownloadOutlined as Download } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

import { errorNormalizer } from "../../../../shared/Helpers/functions";
import {
  CustomAlert,
  CustomButton,
  CustomCheckBox,
} from "../../../../shared/uiComponents";
import { downloadFile } from "../../../Reports/helpers";

import { DispatchProperties, useSelector } from "../../../../redux/store";
import { downloadSoapNotePDF } from "../../../../redux/State/exportSlice";
import { SoapNotesFullProperties } from "../../../../redux/API/ClientAPIHelpers/soapNoteProperties";

const DownloadSOAPNote: FC<{
  data: SoapNotesFullProperties;
}> = ({ data }) => {
  const dispatch = useDispatch<DispatchProperties>();

  const { id, client, submittedAt } = data;

  const [open, setOpen] = useState<boolean>(false);
  const [includeTrials, setIncludeTrials] = useState<boolean>(false);

  const loading = useSelector((state) => state.export.loading);

  const downloadSoapNoteHandler = () => {
    dispatch(
      downloadSoapNotePDF({
        reportId: id,
        includeTrials,
      })
    )
      .then(unwrapResult)
      .then((response) => {
        const date = dayjs(submittedAt).format("MM-DD-YYYY-hh-mm-a");
        downloadFile({
          file: response,
          fileName: `${client.fullName}-${date}`,
        });
      })
      .catch(errorNormalizer)
      .finally(() => setOpen(false));
  };

  const includeTrialsHandler = (event: ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    setIncludeTrials(checked);
  };

  return (
    <>
      <Tooltip title="Download PDF">
        <Download fontSize="small" onClick={() => setOpen(true)} />
      </Tooltip>
      <CustomAlert
        title="Include Trials?"
        open={open}
        onClose={() => setOpen(false)}
        Content={() => (
          <>
            <CustomCheckBox
              item={{
                id: "1",
                checked: includeTrials,
                label: "Include",
              }}
              onChange={includeTrialsHandler}
            />
            <CustomButton
              title="Download PDF"
              onClick={downloadSoapNoteHandler}
              loading={loading}
            />
          </>
        )}
      />
    </>
  );
};

export default DownloadSOAPNote;
